import React, { ReactElement } from 'react';
import { PostHog } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

const PosthogProvider = ({ children, client }: { children: ReactElement; client: PostHog }) => {
  const initializePosthog = ['prod', 'stage', 'qa', 'qa1', 'qa2'].includes(process.env.APP_ENV || '');
  if (initializePosthog) {
    return <PostHogProvider client={client}>{children}</PostHogProvider>;
  }
  return children;
};

export default PosthogProvider;
